module.exports = __webpack_public_path__ + "img/ArrowButtonPre.2dbc949c.png";